import { __assign, __awaiter, __extends, __generator, __rest } from "tslib";
import React from 'react';
import { GALLERY_CONSTS, utils } from '@wix/pro-gallery-lib-old';
import { BlueprintsManager } from '@wix/pro-gallery-blueprints-old';
import ProGallery from './proGallery/proGallery';
import shouldValidate from './typeValidator/shouldValidate';
import { ViewModeWrapperHOC } from './proGallery/viewModeWrapper';
var Gallery = /** @class */ (function (_super) {
    __extends(Gallery, _super);
    function Gallery(props) {
        var _this = _super.call(this, props) || this;
        _this.isUsingCustomInfoElements = _this.isUsingCustomInfoElements.bind(_this);
        _this.blueprintsManager = new BlueprintsManager({ id: 'layoutingGallery' });
        _this.blueprintsManager.init({
            deviceType: props.deviceType,
            api: {
                isUsingCustomInfoElements: _this.isUsingCustomInfoElements,
                fetchMoreItems: function (from) {
                    typeof props.eventsListener === 'function' &&
                        props.eventsListener(GALLERY_CONSTS.events.NEED_MORE_ITEMS, from);
                },
                onBlueprintReady: function (_a) {
                    var blueprint = _a.blueprint, blueprintChanged = _a.blueprintChanged, initialBlueprint = _a.initialBlueprint;
                    if (blueprintChanged) {
                        _this.setBlueprint(blueprint, initialBlueprint);
                    }
                    else {
                        if (utils.isVerbose()) {
                            console.count('>>> Blueprint not changed, not setting it');
                        }
                    }
                },
            },
        });
        _this.onNewProps(props, true);
        _this.state = {
            blueprint: _this.blueprintsManager.createInitialBlueprint(props) || null,
        };
        return _this;
    }
    Gallery.prototype.setBlueprint = function (blueprint, initialBlueprint) {
        if (initialBlueprint) {
            // the blueprint from the initial blueprint flow will be set in the constructor
        }
        else {
            this.setState({ blueprint: blueprint });
        }
    };
    Gallery.prototype.isUsingCustomInfoElements = function () {
        return (!!this.galleryProps.customComponents.customHoverRenderer ||
            !!this.galleryProps.customComponents.customInfoRenderer);
    };
    Gallery.prototype.onNewProps = function (props, calledByConstructor) {
        var _this = this;
        var eventsListener = props.eventsListener, otherProps = __rest(props, ["eventsListener"]);
        var _eventsListener = function (eventName, eventData, event) {
            if (eventName === GALLERY_CONSTS.events.NEED_MORE_ITEMS) {
                _this.blueprintsManager.getMoreItems(eventData);
            }
            else {
                typeof eventsListener === 'function' &&
                    eventsListener(eventName, eventData, event);
            }
        };
        this.galleryProps = __assign(__assign({}, otherProps), { eventsListener: _eventsListener, id: props.id || 'default-dom-id', customComponents: props.customComponents || {} });
        if (calledByConstructor) {
            // the blueprint will be initiated with the state!
        }
        else {
            this.blueprintsManager.createBlueprint(this.galleryProps).catch(function (e) {
                //TODOVER3 check totalItemsCount
                console.error('Could not create a blueprint from the new props', e);
            });
        }
    };
    Gallery.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        this.onNewProps(newProps, false);
    };
    Gallery.prototype.render = function () {
        var _a = this.state, blueprint = _a.blueprint, typeErrors = _a.typeErrors;
        if (typeErrors) {
            return typeErrors;
        }
        if (blueprint && Object.keys(blueprint).length > 0) {
            return React.createElement(ProGallery, __assign({}, this.galleryProps, blueprint));
        }
        else {
            return null;
        }
    };
    Gallery.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validateTypesModule, validate, typeErrorsUI, typeErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (shouldValidate(this.props, utils.isSSR()) === false) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "proGallery_validateTypes" */ './typeValidator/validateTypes')];
                    case 1:
                        validateTypesModule = _a.sent();
                        validate = validateTypesModule.validate, typeErrorsUI = validateTypesModule.typeErrorsUI;
                        typeErrors = validate(this.state.blueprint.options);
                        if (typeErrors.length > 0) {
                            this.setState({ typeErrors: typeErrorsUI(typeErrors) });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Gallery;
}(React.Component));
export default ViewModeWrapperHOC(Gallery);
//# sourceMappingURL=index.js.map